
/***

	NavBar - variant: contrast
	--------------------------
	
		
		- opaque
		- contrasting colors 
		- broad header

*/

import 
	React, 
	{ 
		useState,
		useEffect,
		useRef
	} 						from 'react';

import { 
	Link,
	useLocation 
} 							from "react-router-dom"
import { auth } 			from "../utils/firebase";
import { useAuthState } 	from "react-firebase-hooks/auth";

import CustomLink 			from "./CustomLink"; 



export default function Navbar() {

	const [user, loading] 			= useAuthState(auth);

	const location 					= useLocation();

	// Controleer of de huidige locatie de homepage is
	const isHomePage 				= location.pathname === '/';



	// Hamburger menu (voor mobile)
	const [menuOpen, setMenuOpen] 	= useState(false);

	const [imageError, setImageError] = useState(false);

	useEffect(() => {
		setImageError(false);
	}, [user]);



	const toggleMenu = () => {

		setMenuOpen( ! menuOpen );
	};



	const [profileMenuOpen, setProfileMenuOpen] 	= useState(false);
	const profileMenuRef 							= useRef(null);

	useEffect(

		() => {

			const handleClickOutside = (event) => {
				if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
					setProfileMenuOpen(false);
				}
			};

			document.addEventListener("mousedown", handleClickOutside);

			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		},

		[]
	);






  	return (

		<>
			{/* nav guitarpilgrim style */}
			<nav 
				className			= "nav"
			>

			{/* 
				[ ] todo:
					implement nav miro style 
			*/}
			{/* <nav 
				className			= "navbar"
			> */}


				{/* 
					Hamburger menu - mobile (Tijdelijk uitgeschakeld)
				
				<button className="menu-button" onClick={toggleMenu}>
					☰
				</button>
				*/}

				{/* Off-canvas - mobile */}
				<div 
					className			= {`offcanvas ${menuOpen ? 'open' : ''}`}
				>
					<button 
						className			= "offcanvas-close-button" 
						onClick				= {toggleMenu}
					>
						✕
					</button>

					<ul className			= "offcanvas-list">
						
						<CustomLink to="/">					Hadfome			</CustomLink>



						{
							user

							? 
							
							(
								<NavButton 
									to="/" 
									onClick={() => auth.signOut()}
								>
															Logout
								</NavButton>
							) 
							
							: 
							
							(
								<CustomLink to="/login">	
															Login			
								</CustomLink>
						)}



						{
							! user

							? 
							
							<CustomLink to="/Signup">		Sign up		</CustomLink> 
							
							: 
							
							null
						}

						 
					</ul>
				</div>



				{/* Site title */}
				<Link 
					to					= "/"
					className 			= {`site-title ${isHomePage ? 'large' : 'small'}`}
				>
					{/* 
						(jan 25)
						
						[ ] nog iets met icon doen?

							[ ] moet ook nog styling die samengaat met site-title.large en site-title.small

					*/}

					<img 
						src="/moonpiko.png" 
						alt="Logo" 
						className="link-icon"
					/> 
					
					NodePony
				
				</Link>



				{/* Right section (Profile menu / Nav links) */}
				<div className="nav-right">
					{
						user 
						? 
						(
							<div className="profile-menu-container" ref={profileMenuRef}>
								<button 
									className="profile-trigger" 
									onClick={() => setProfileMenuOpen(!profileMenuOpen)}
									aria-label="Toggle profile menu"
								>
									{
										user.photoURL && !imageError
										? 
										(
											<img 
												src={user.photoURL} 
												alt="Profile" 
												className="profile-avatar" 
												referrerPolicy="no-referrer"
												onError={() => setImageError(true)}
											/>
										) 
										: 
										(
											<svg className="profile-avatar" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="16" cy="16" r="16" fill="#007bff" />
												<path d="M16 14C18.2091 14 20 12.2091 20 10C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10C12 12.2091 13.7909 14 16 14Z" fill="white" />
												<path d="M6 26.5C6 22.3579 10.4772 19 16 19C21.5228 19 26 22.3579 26 26.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
											</svg>
										)
									}
								</button>

								{
									profileMenuOpen 
									&& 
									(
										<div className="profile-dropdown">
											<div className="profile-dropdown-header">
												<span className="profile-email">{user.email}</span>
											</div>
											<div className="profile-dropdown-divider"></div>
											<ul className="profile-dropdown-list">
												<li>
													<Link to="/" onClick={() => setProfileMenuOpen(false)}>Home</Link>
												</li>
												<li>
													<button className="dropdown-logout-btn" onClick={() => { auth.signOut(); setProfileMenuOpen(false); }}>
														Logout
													</button>
												</li>
											</ul>
										</div>
									)
								}
							</div>
						) 
						: 
						(
							<ul className="nav-menu">

								<CustomLink to="/">					Home			</CustomLink>

								<CustomLink to="/login">			Login			</CustomLink>

								<CustomLink to="/Signup">			Sign up			</CustomLink>

							</ul>
						)
					}
				</div>
			</nav>
		</>
  	)
}






/***  
	[ ] nu maar ff aparte component van gemaakt want deze werd actief (waarschijnlijk omdat ie ok naar Home verwees) (dec 23)
*/
function NavButton({ to, children, ...props }) {

  	// const resolvedPath = useResolvedPath(to)
	const isActive = false

	return (
		<li 
			className={isActive ? "active" : ""}
		>
			<Link to={to} {...props}>
				{children}
			</Link>
		</li>
	)
}